import React from 'react';

export default function Home() {
    return (
        <div>
            <h1>Welcome to Solufo RMS</h1>
            <p>Not sure what we'll do here.</p>
        </div>
    );
}